export default {
  title: 'Bestelldetails',
};
